"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CodePane = void 0;
const classnames_1 = __importDefault(require("classnames"));
const monaco = __importStar(require("monaco-editor"));
const react_1 = __importStar(require("react"));
const Icon = __importStar(require("../icons/index"));
const Components_1 = require("./Components");
const styles = __importStar(require("./style/Code"));
const Components_2 = require("./style/Components");
const index_1 = require("./monaco/index");
const index_2 = require("../../worker/index");
const cypress_constants_1 = require("../../cypress_constants");
const vars_1 = require("../../vars");
const index_3 = require("../../state/containers/index");
monaco.languages.register({ id: 'graphqle' });
monaco.languages.setLanguageConfiguration('graphqle', index_1.conf);
monaco.languages.setMonarchTokensProvider('graphqle', index_1.language);
monaco.editor.defineTheme('graphql-editor', index_1.theme);
exports.CodePane = (props) => {
    const { schema, libraries = '', onChange, readonly, size, scrollTo } = props;
    const editor = react_1.useRef(null);
    const [monacoGql, setMonacoGql] = react_1.useState();
    const [decorationIds, setDecorationIds] = react_1.useState([]);
    const { codeErrors, setCodeErrors, setLockGraf } = index_3.useErrorsState();
    const { setActions } = index_3.useIOState();
    const generateEnabled = !readonly && codeErrors.length === 0;
    react_1.useEffect(() => {
        var _a;
        if (scrollTo) {
            const items = (_a = monacoGql === null || monacoGql === void 0 ? void 0 : monacoGql.getModel()) === null || _a === void 0 ? void 0 : _a.findNextMatch(scrollTo, { column: 0, lineNumber: 0 }, false, false, null, true);
            if (items) {
                const { range: { startLineNumber, endLineNumber, startColumn, endColumn }, } = items;
                monacoGql === null || monacoGql === void 0 ? void 0 : monacoGql.setPosition({
                    column: 0,
                    lineNumber: startLineNumber,
                });
                monacoGql === null || monacoGql === void 0 ? void 0 : monacoGql.setPosition({ column: 0, lineNumber: startLineNumber });
                monacoGql === null || monacoGql === void 0 ? void 0 : monacoGql.revealPositionInCenter({ column: 0, lineNumber: startLineNumber }, monaco.editor.ScrollType.Smooth);
                monacoGql === null || monacoGql === void 0 ? void 0 : monacoGql.setSelection({
                    startLineNumber,
                    endLineNumber,
                    startColumn,
                    endColumn,
                });
            }
        }
    }, [scrollTo]);
    react_1.useEffect(() => {
        if (editor.current) {
            monacoGql === null || monacoGql === void 0 ? void 0 : monacoGql.dispose();
            const model = monacoGql === null || monacoGql === void 0 ? void 0 : monacoGql.getModel();
            if (model) {
                model.dispose();
            }
            const m = monaco.editor.create(editor.current, index_1.settings());
            m.updateOptions({
                readOnly: readonly,
                fontFamily: vars_1.fontFamily,
            });
            monaco.editor.remeasureFonts();
            m.setValue(schema);
            m.onDidChangeModelContent((e) => {
                const value = m.getModel().getValue();
                index_2.Workers.validate(value, libraries).then((errors) => {
                    setCodeErrors(errors);
                });
            });
            m.onDidBlurEditorText(() => {
                const value = m.getModel().getValue();
                if (value.length === 0) {
                    onChange(value);
                    return;
                }
                index_2.Workers.validate(value, libraries).then((errors) => {
                    if (errors.length === 0) {
                        onChange(value);
                        setLockGraf(false);
                    }
                });
            });
            setMonacoGql(m);
            setTimeout(() => m.layout(), 100);
        }
        return () => monacoGql === null || monacoGql === void 0 ? void 0 : monacoGql.dispose();
    }, [libraries, readonly]);
    react_1.useEffect(() => {
        if (monacoGql) {
            const monacoDecorations = codeErrors.map(index_1.mapEditorErrorToMonacoDecoration);
            const newDecorationIds = monacoGql.deltaDecorations(decorationIds, monacoDecorations);
            setDecorationIds(newDecorationIds);
        }
    }, [JSON.stringify(codeErrors), monacoGql]);
    react_1.useEffect(() => {
        function handleResize() {
            monacoGql === null || monacoGql === void 0 ? void 0 : monacoGql.layout();
        }
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [monacoGql]);
    react_1.useEffect(() => {
        monacoGql === null || monacoGql === void 0 ? void 0 : monacoGql.layout();
    }, [size]);
    react_1.useEffect(() => {
        var _a;
        const v = (_a = monacoGql === null || monacoGql === void 0 ? void 0 : monacoGql.getModel()) === null || _a === void 0 ? void 0 : _a.getValue();
        if (v !== schema) {
            const cursorPos = monacoGql === null || monacoGql === void 0 ? void 0 : monacoGql.getPosition();
            monacoGql === null || monacoGql === void 0 ? void 0 : monacoGql.setValue(schema);
            if (cursorPos) {
                monacoGql === null || monacoGql === void 0 ? void 0 : monacoGql.setPosition(cursorPos);
            }
        }
    }, [schema, monacoGql]);
    react_1.useLayoutEffect(() => {
        monaco.editor.remeasureFonts();
    }, [schema]);
    const monacoEditorModel = monacoGql === null || monacoGql === void 0 ? void 0 : monacoGql.getModel();
    const monacoEditorValue = monacoEditorModel && monacoEditorModel.getValue();
    react_1.useEffect(() => {
        setActions((acts) => (Object.assign(Object.assign({}, acts), { [index_3.KeyboardActions.Save]: () => {
                var _a;
                const v = (_a = monacoGql === null || monacoGql === void 0 ? void 0 : monacoGql.getModel()) === null || _a === void 0 ? void 0 : _a.getValue();
                if (v && generateEnabled) {
                    index_2.Workers.validate(v, libraries).then((errors) => {
                        if (errors.length === 0) {
                            onChange(v);
                            setLockGraf(false);
                            return;
                        }
                    });
                }
            } })));
    }, [monacoGql, codeErrors]);
    const holder = react_1.useRef(null);
    const syncStatus = readonly
        ? Components_2.StatusDotProps.readonly
        : monacoEditorValue !== schema
            ? Components_2.StatusDotProps.nosync
            : Components_2.StatusDotProps.sync;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Components_1.TitleOfPane, null,
            react_1.default.createElement("div", { className: classnames_1.default(styles.Generate, {
                    disabled: !generateEnabled,
                    ready: generateEnabled && syncStatus === Components_2.StatusDotProps.nosync,
                }), onClick: () => {
                    if (generateEnabled && monacoEditorValue) {
                        onChange(monacoEditorValue);
                    }
                } }, generateEnabled ? (syncStatus === Components_2.StatusDotProps.sync ? ('') : (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("span", { style: { marginRight: 5 } }, "synchronize"),
                react_1.default.createElement(Icon.Settings, { size: 14 })))) : readonly ? ('readonly') : ('')),
            react_1.default.createElement(Components_1.StatusDot, { status: syncStatus })),
        react_1.default.createElement("div", { className: classnames_1.default(styles.CodeContainer), ref: holder, "data-cy": cypress_constants_1.cypressGet(cypress_constants_1.GraphQLEditorCypress, 'sidebar', 'code', 'name') },
            react_1.default.createElement("div", { ref: editor, className: styles.Editor }))));
};
